import { Box, Skeleton, Stack,  } from "@mui/material";



export const CounterMetricCardLoader = () => {


  return (
    <Box sx={styles.container}>
      <Stack height={120} direction="column" spacing={2} alignItems="center" py={1}>
        <Stack width="100%">
          <Box sx={styles.iconWrapper}>
          <Skeleton variant="circular" width={30} height={30} />
          </Box>
          <Stack width={"100%"} alignItems={"center"} mt={0.5}>
          <Skeleton variant="text" width={150} height={20} />
          </Stack>
       
        </Stack>
        <Skeleton variant="text" width={50} height={50} />
      </Stack>
    </Box>
  );
};

const styles = {
  container: {
    width: 250,
    height: 120,
    borderRadius: 2,
    transition: "all 0.1s ease-in-out",
    cursor: "pointer",
    padding:1,

    boxShadow:
    "rgba(0, 0, 0, 0.02) 0px 2px 4px, rgba(0, 0, 0, 0.1) 0px 7px 13px -3px, rgba(102, 187, 106, 1) 0px 0px 0px inset",


  },
  iconWrapper: {
    position: "absolute",
  }

};
